import React, { useEffect, useState } from "react";

import Header from "@/Components/Headers/Components/Header";
import LockIcon from "@/Components/Icons/LockIcon";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type AppUserSession } from "@/schemas/auth/session";
import { type MediaManagerScreenState } from "@/schemas/screen/configs";
import { MediaManagerTabs, Screen } from "@/schemas/screen/tabs";

type Props = {
  session: AppUserSession;
};

function MediaManagerHeader({ session }: Props): React.JSX.Element {
  const { currentScreen, setCurrentScreen } = useHeaderContext();
  const [currentTab, setCurrentTab] = useState<MediaManagerTabs>(
    MediaManagerTabs.PUBLIC,
  );

  useEffect(() => {
    if (currentScreen.screenId === Screen.MEDIA_MANAGER) {
      setCurrentTab(currentScreen.activeTabId);
    }
  }, [currentScreen]);

  const handleTabPress = (tab: MediaManagerTabs): void => {
    const newMediaTabScreen: MediaManagerScreenState = {
      screenId: Screen.MEDIA_MANAGER,
      activeTabId: tab,
      filters: null,
    };
    setCurrentScreen(newMediaTabScreen);
  };

  return (
    <Header
      tabs={[
        {
          isActive: currentTab === MediaManagerTabs.PUBLIC,
          onPress: () => handleTabPress(MediaManagerTabs.PUBLIC),
          title: "Public",
        },
        {
          isActive: currentTab === MediaManagerTabs.PRIVATE,
          onPress: () => handleTabPress(MediaManagerTabs.PRIVATE),
          title: "Private",
        },
      ]}
      rightComponent={
        currentTab === MediaManagerTabs.PRIVATE && (
          <LockIcon
            hasPendingRequests={session.identity.privateAlbumnRequestsCount > 0}
          />
        )
      }
    />
  );
}

export default MediaManagerHeader;
